import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaCovid from '../../components/licitacao/listar';


function CovidScreen () {
    return (
        <Fragment>
            <Head titulo="Licitações feitas durante a pandemia de COVID-19 no Município de Macuco"/>
            <Header />
            <Container>
                <ListaCovid />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CovidScreen;